module.exports = __webpack_public_path__ + "media/honey-icons/icon-bluetooth-eca13cc8.svg";